var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticStyle:{"border-radius":"50%"},attrs:{"src":_vm.cover,"width":"100px","height":"100px"}}),_c('p',[_vm._v(_vm._s(_vm.index)+" "+_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }